<style scoped lang="scss">

</style>

<template>
  <div>

    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='Link' :href="`/sector-targets/${business.sector_target_id}`">Sector Targets</b-breadcrumb-item>
      <b-breadcrumb-item tag='Link' active>
        {{ business.name }} {{business.sector_target.vertical.name}} - {{business.sector_target.market.label}}
      </b-breadcrumb-item>
    </b-breadcrumb>

    <section class="section">
      <h2 class="title">
        {{business.name}}
      </h2>

      <div class="columns">
        <div class="column">
          <div class="panel">
            <div class="panel-heading">
              <h2 class="panel-title">Market</h2>
            </div>
            <div class="panel-block">
              <Link :href="`/markets/${business.sector_target.market.id}/edit`">{{ business.sector_target.market.city }}, {{ business.sector_target.market.state }}</Link>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="panel">
            <div class="panel-heading">
              <h2 class="panel-title">Vertical</h2>
            </div>
            <div class="panel-block">
              <Link :href="`/verticals/${business.sector_target.vertical.id}/edit`">{{ business.sector_target.vertical.name }}</Link>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="panel">
            <div class="panel-heading">
              <h2 class="panel-title">Contacts</h2>
            </div>
            <div class="panel-block">
              {{ business.contacts.length }}
            </div>
          </div>
        </div>

      </div>
    </section>
    <card-component title="Address">
      <div class="card-content">
          <p>{{ business.address }}</p>
          <p>{{ business.city }}, {{ business.state }} {{ business.zip }}</p>
      </div>
    </card-component>
    <card-component title="Contacts">
      <div class="card-header-icon">
        </div>
          <div class="card-content">
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Address</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="contact in business.contacts" :key="contact.id">
              <td>{{ contact.first_name }} {{ contact.last_name }}</td>
              <td>{{ contact.email }}</td>
              <td>{{ contact.phone }}</td>
              <td>{{ contact.address }} {{ contact.city }}, {{ contact.region }} {{ contact.zip }} </td>
              <td>
                <b-tooltip
                  type="is-dark"
                  position="is-left"
                  :label="contact.user ? 'User already exists.' : 'Assign or Invite New User'">
                  <Link class="button"
                        method="get"
                        :disabled="contact.user"
                        :class="{'is-primary': contact.user}"
                        @click="openUserInviteModal(contact)">
<!--                        :href="`/businesses/${business.id}/invite-contact/${contact.id}`"-->
                    <i class="fa fa-user-plus"></i>
                  </Link>
                </b-tooltip>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <footer class="card-footer">
        <Link :href="`/contacts/create/${business.sector_target.id}?type=business&contactable_id=${business.id}`" class=" card-footer-item button is-primary">Create Contact</Link>
      </footer>
    </card-component>

    <card-component title="Notes">
      <div class="card-content">
        <p>{{ business.notes }}</p>
      </div>
      <footer class="card-footer">
        <Link href="" class=" card-footer-item button is-primary">New Note</Link>
      </footer>
    </card-component>

  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue2'
import Layout from '@/Shared/Layout'
import CardComponent from "@/Shared/CardComponent.vue";
import InviteUser from '@/Pages/Businesses/InviteUser.vue'
export default {
  components: {
    CardComponent,
    InviteUser,
    Head,
    Link,
  },
  layout: Layout,
  props: {
    business: Object,
  },
  data() {
    return {
    }
  },
  computed: {
    full_address() {
      let address_lines = (this.business.address2 ?
        this.business.address+' '+this.business.address2 : this.business.address );
      return [address_lines, this.business.city,
        this.business.state, this.business.postal_code].join(', ');
    }
  },
  methods: {
    openUserInviteModal(contact){
      this.$buefy.modal.open({
        component: InviteUser,
        props:{
          business: this.business,
          contact: contact
        },
        parent: this,
        hasModalCard: true,
        trapFocus: true

      })
    }
  }
}
</script>
